import "./index.css";

export const ProveedoresPreimpresos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Administrar proveedores preimpresos</h1>
      </div>
    </div>
  );
};
